<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_hygiene_policy" name="is_hygiene_policy" rules="" v-slot="{ errors }">
              <small class="label">9.1 Do you have a written Hygiene Policy?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_hygiene_policy" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_hygiene_policy" vid="is_hygiene_policy_text" name="is_hygiene_policy_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes, please specify</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="is_hygiene_policy_text" class="w-full" v-model="form.is_hygiene_policy_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_hygiene_schedules" name="is_hygiene_schedules" rules="" v-slot="{ errors }">
              <small class="label">9.2 Do you have written Hygiene Schedules?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_hygiene_schedules" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_hygiene_schedules" vid="is_hygiene_schedules_text" name="is_hygiene_schedules_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes, please specify</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="is_hygiene_schedules_text" class="w-full" v-model="form.is_hygiene_schedules_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-full w-full md:mb-0">
            <ValidationProvider vid="cleaning_in_house" name="cleaning_in_house" rules="required" v-slot="{ errors }">
              <small class="label">9.3 Is cleaning by in-house staff or contracted?</small>
              <v-select :disabled="__isDisabledRawMaterial(status)" name="cleaning_in_house" :closeOnSelect="true" v-model="form.cleaning_in_house" :options="['in-house-staff', 'contracted']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_comply_coshh" name="is_comply_coshh" rules="" v-slot="{ errors }">
              <small class="label">9.4 Are staff trained to comply with COSHH?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_comply_coshh" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_comply_coshh" vid="is_comply_coshh_text" name="is_comply_coshh_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes, please specify</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="is_comply_coshh_text" class="w-full" v-model="form.is_comply_coshh_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_swab_on_sites" name="is_swab_on_sites" rules="" v-slot="{ errors }">
              <small class="label">9.5 Do you carry out any swabs on site to validate cleaning effectiveness</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_swab_on_sites" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_swab_on_sites" vid="is_swab_on_sites_text" name="is_swab_on_sites_text" rules="" v-slot="{ errors }">
              <small class="label">If yes, please specify</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="is_swab_on_sites_text" class="w-full" v-model="form.is_swab_on_sites_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_hygiene_audit" name="is_hygiene_audit" rules="" v-slot="{ errors }">
              <small class="label">9.6 Are hygiene audits carried out? </small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_hygiene_audit" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_hygiene_audit" vid="is_hygiene_audit_whom" name="is_hygiene_audit_whom" rules="required" v-slot="{ errors }">
              <small class="label"> and by whom?</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="is_hygiene_audit_whom" class="w-full" v-model="form.is_hygiene_audit_whom" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_hygiene_audit" vid="is_hygiene_audit_whom" name="is_hygiene_audit_whom" rules="" v-slot="{ errors }">
              <small class="label"> If yes, please supply a copy</small>
              <a target="_blank" v-if="form.hygiene_audit_file" class="float-right" :href="form.hygiene_audit_file">view file</a>
              <vs-input :disabled="__isDisabledRawMaterial(status)" @change="onUploadFile($event)" type="file" name="is_hygiene_audit_whom" class="w-full"/>
              <span v-if="formUploadRequired001" class="text-danger text-sm">This field is required</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_cleaning_procedures" name="is_cleaning_procedures" rules="" v-slot="{ errors }">
              <small class="label">9.7 Do you have documented cleaning procedures and schedules? </small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_cleaning_procedures" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 md:mb-0">
            <ValidationProvider v-if="form.is_cleaning_procedures" vid="is_effectiveness_verified" name="is_effectiveness_verified" rules="" v-slot="{ errors }">
              <small class="label">Is their effectiveness verified?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_effectiveness_verified" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_hygiene_training" name="is_hygiene_training" rules="" v-slot="{ errors }">
              <small class="label">9.8 Do all food handlers receive hygiene training? If yes, please give details</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_hygiene_training" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_hygiene_training" vid="is_hygiene_training_text" name="is_hygiene_training_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes, please specify</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="is_hygiene_training_text" class="w-full" v-model="form.is_hygiene_training_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_medical_screening" name="is_medical_screening" rules="" v-slot="{ errors }">
              <small class="label">9.9 Do you carry out any medical (or return to work) screening of food handlers, either prior to starting or during employment? If yes, please give details</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_medical_screening" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_medical_screening" vid="is_medical_screening_text" name="is_medical_screening_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes, please specify</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="is_medical_screening_text" class="w-full" v-model="form.is_medical_screening_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_personal_hygiene" name="is_personal_hygiene" rules="" v-slot="{ errors }">
              <small class="label">9.10 Do you have written rules for personnel hygiene?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_personal_hygiene" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_personal_hygiene" vid="is_personal_hygiene_text" name="is_personal_hygiene_text" rules="" v-slot="{ errors }">
              <small class="label">If yes, please provide a copy</small>
              <a target="_blank" v-if="form.is_personal_hygiene_text" class="float-right" :href="form.is_personal_hygiene_text">view file</a>
              <vs-input :disabled="__isDisabledRawMaterial(status)"  @change="onUploadFilePersonHygiene($event)" type="file" name="is_personal_hygiene_text" class="w-full"/>
              <span v-if="formUploadRequired002" class="text-danger text-sm">This field is required</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-full w-full md:mb-0">
            <ValidationProvider vid="protective_clothing" name="protective_clothing" rules="required" v-slot="{ errors }">
              <small class="label">9.11 How frequently is protective clothing changed?</small>
              <v-select :disabled="__isDisabledRawMaterial(status)" name="protective_clothing" :closeOnSelect="true" v-model="form.protective_clothing" :options="['weekly', 'monthly', 'quarterly', 'half-yearly','yearly']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-2/5 md:mb-0">
            <ValidationProvider vid="is_medical_question" name="is_medical_question" rules="" v-slot="{ errors }">
              <small class="label">9.12 Are visitors to the food production area required to complete a medical questionnaire?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_medical_question" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-3/5 w-full md:mb-0">
            <ValidationProvider v-if="form.is_medical_question" vid="is_medical_question_text" name="is_medical_question_text" rules="required" v-slot="{ errors }">
              <small class="label">If yes, please specify</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="is_medical_question_text" class="w-full" v-model="form.is_medical_question_text" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>

        <div class="flex flex-wrap items-center justify-end">
          <vs-button v-if="status.is_supplier_manufacture_site_hygiene_complete === 1"  button="submit" class="ml-auto mt-2" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRepository = RepositoryFactory.get('supplier')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";

  export default {
    name: "SupplierManufacturingHome",
    data() {
      return {
        form: {
          is_hygiene_policy: false,
          is_hygiene_schedules: false,
          is_comply_coshh: false,
          is_swab_on_sites: false,
          is_hygiene_audit: false,
          is_cleaning_procedures: false,
          is_effectiveness_verified: false,
          is_hygiene_training: false,
          is_medical_screening: false,
          is_personal_hygiene: false,
          is_medical_question: false,
        },
        id: null,
        status: {},
        formUploadRequired001: false,
        formUploadRequired002: false
      }
    },
    components: {
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      onClickSubmit() {
        this.status.is_supplier_manufacture_site_hygiene_complete === 1 ? this.onClickUpdate() : this.onClickCreate()
      },
      async onClickUpdate() {
        this.$vs.loading()
        try {
          const data= (await SupplierManufactureRepository.UpdateManufactureHygienesDetails(this.id, this.form))
          this.showSuccessMessage('Manufacture Hygiene Details Updated!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreate() {
        if (this.form.is_hygiene_audit && !this.form.hygiene_audit_file) {
          this.formUploadRequired001 = true
        } else if((this.form.is_personal_hygiene && !this.form.is_personal_hygiene_text)){
          this.formUploadRequired002 = true
        } else{
          this.$vs.loading()
          try {
            const data= (await SupplierManufactureRepository.CreateManufactureHygienesDetails(this.form))
            this.showSuccessMessage('Manufacture Hygiene Details Created!')
            this.onClickNext()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        }
      },

      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierManufactureRepository.getManufactureHygienesDetails(this.id)).data
        this.form =data
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierManufactureRepository.getManufactureSiteStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      },
      async onUploadFile(event) {
        this.$vs.loading();
        try {
          const file = await event.target.files[0]
          let formData = new FormData();
          formData.append('file', file);
          this.form.hygiene_audit_file = (await SupplierRepository.uploadFile(formData)).data.data.file
          this.showSuccessMessage('Document Uploaded!')
          this.formUploadRequired001 = false
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onUploadFilePersonHygiene(event) {
        this.$vs.loading();
        try {
          const file = await event.target.files[0]
          let formData = new FormData();
          formData.append('file', file);
          this.form.is_personal_hygiene_text = (await SupplierRepository.uploadFile(formData)).data.data.file
          this.formUploadRequired002 = false
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_manufacture_site_id =  this.id
      await this.loadStatus()
      if (this.status.is_supplier_manufacture_site_hygiene_complete === 1 ) {
        await this.loadData()
      }
    }

  }
</script>

<style scoped>

</style>
